<!-- declaration.component.html -->

<form [formGroup]="declarationForm" class="declaration-form">
  <div class="scroll-content">
    <h3 class="declaration-title">Declaração de Ausência de Conflito de Interesse e Compromisso de Sigilo</h3>

    <div class="mat-typography">
      <div class="form-fields">
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Nome completo</mat-label>
            <input matInput formControlName="nome" required />
            <mat-icon matSuffix>person</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" id="input-nacionalidade">
            <mat-label>Nacionalidade</mat-label>
            <input matInput formControlName="nacionalidade" required />
            <mat-icon matSuffix>flag</mat-icon>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Profissão</mat-label>
            <input matInput formControlName="profissao" required />
            <mat-icon matSuffix>work</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" id="input-endereco">
            <mat-label>Endereço residencial</mat-label>
            <input matInput formControlName="residencia" required />
            <mat-icon matSuffix>home</mat-icon>
          </mat-form-field>
        </div>

        <div class="document-preview">
          <p class="text">
            Eu,
            <strong [ngClass]="{ danger: !declarationForm.value.nome }">{{ declarationForm.value.nome || '(nome)' }}</strong
            >,
            <strong [ngClass]="{ danger: !declarationForm.value.nacionalidade }">{{
              declarationForm.value.nacionalidade || '(nacionalidade)'
            }}</strong
            >,
            <strong [ngClass]="{ danger: !declarationForm.value.profissao }">{{
              declarationForm.value.profissao || '(profissão)'
            }}</strong
            >, residente à
            <strong [ngClass]="{ danger: !declarationForm.value.residencia }">{{
              declarationForm.value.residencia || '(residência)'
            }}</strong
            >, membro da Comissão Examinadora/ Julgadora do concurso público/processo seletivo público aberto pela
            Universidade Estadual de Campinas – Unicamp, para preenchimento do cargo/função de
            <strong [ngClass]="{ danger: !info?.tipoConcurso }">{{ info?.tipoConcurso || '(função do concurso)' }}</strong>
            junto a(ao)
            <strong [ngClass]="{ danger: !info?.unidadeConcurso }">{{
              info?.unidadeConcurso || '(faculdade/instituto/órgão)'
            }}</strong
            >, referente ao
            <strong [ngClass]="{ danger: !info?.processoSigadConcurso }">{{
              info?.processoSigadConcurso ? 'processo n.º ' + info?.processoSigadConcurso : '(processo n.º /Edital n.º)'
            }}</strong>
            , DECLARO, sob as penas da lei, especialmente do artigo 299 do Código Penal Brasileiro, o seguinte:
          </p>

          <p class="text">
            1) que recebi cópia e tenho ciência do teor das Resoluções GR-022/2016 e GR-050/2024, que dispõem sobre o
            conflito de interesses na composição das Comissões Examinadoras e Julgadoras de concursos públicos e processos
            seletivos para provimento de cargos e funções na Unicamp;
          </p>

          <p class="text">2) que, ciente da lista de inscritos:</p>

          <mat-radio-group formControlName="possuiConflito">
            <p class="text" id="seletor-termo">
              <mat-radio-button color="primary" [value]="false"></mat-radio-button> não me encontro em nenhuma das situações
              a seguir enumeradas com relação a qualquer dos candidatos ao concurso público/processo seletivo público:
            </p>

            <div class="indent">
              <p>
                I – vínculos familiares entre membro e candidato: cônjuges, companheiro, parente consanguíneo ou afim, em
                linha reta ou colateral até o terceiro grau, ocorrendo o mesmo para quem for ou tiver sido enteado, cônjuge
                ou companheiro;
              </p>

              <p>II – supervisor de aluno bolsista;</p>

              <p>III – supervisor ou orientador de estagiário (ex ou atual);</p>

              <p>IV – orientador de TCC (ex-aluno ou atual);</p>

              <p>V – orientador ou co-orientador de mestrado/doutorado, ou de iniciação científica (ex-aluno ou atual);</p>

              <p>VI – supervisor de pós-doutorado (ex ou atual);</p>

              <p>VII – vínculo de chefia/gerência entre membro da comissão e candidato;</p>

              <p>VIII – mais de uma colaboração em atividades de pesquisa e publicações nos últimos 05 (cinco) anos;</p>

              <p>IX – integrantes do mesmo grupo de pesquisa na Universidade nos últimos 05 (cinco) anos;</p>

              <p>X – manutenção de relações comerciais entre membro da comissão e candidato;</p>

              <p>
                XI – convívio no ambiente de trabalho ou fora dele, com o estabelecimento de relacionamento pessoal
                relevante;
              </p>
            </div>

            <p class="text">
              e que, além das hipóteses previstas no rol desta declaração, não me encontro em nenhuma outra situação que
              possa caracterizar conflito de interesse e que comprometa o julgamento isento do concurso público/processo
              seletivo público.
            </p>

            <p class="text">
              <mat-radio-button color="primary" [value]="true"> </mat-radio-button> que a situação a seguir descrita e
              justificada não caracteriza conflito de interesse que possa comprometer o julgamento isento do concurso
              público/processo seletivo público:
            </p>
          </mat-radio-group>

          <div class="justificativa-container" *ngIf="declarationForm.get('possuiConflito')?.value === true">
            <mat-form-field appearance="outline">
              <mat-label>Descreva a situação e justificativa</mat-label>
              <textarea matInput formControlName="justificativa" required rows="4"></textarea>
            </mat-form-field>
          </div>

          <p class="text">
            3) que, se for questionado sobre eventual conflito de interesse, deverei prestar esclarecimento por escrito,
            indicando os motivos que me levaram a não considerar aquela determinada situação impugnada como não conflituosa.
          </p>

          <p class="text">
            4) Por meio do presente termos comprometo-me a manter sigilo das informações referentes concurso público e das
            informações pessoais dos candidatos inscritos no mesmo.
          </p>
          <p>Campinas, {{ now() | date : 'dd/MM/yyyy' }}</p>
        </div>
      </div>
    </div>
  </div>

  <mat-card class="card-info card-icon ciencia-container">
    <mat-checkbox color="primary" formControlName="cienciaDados" name="cienciaDados" id="seletor-ciencia-dados">
      Tenho ciência que para a assinatura digital da declaração ser efetivada é utilizado o assinador de documentos da
      RNP (Rede Nacional de Pesquisa) que precisa dos seguintes dados:
      <strong>Nome, data de nascimento e CPF/Passaporte.</strong>
    </mat-checkbox>
  </mat-card>
</form>
